define('home/templates/feedEmpty',['handlebars', 'handlebars.partials', 'core/extensions/handlebars.helpers'], function(Handlebars) {

return Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return container.escapeExpression(helpers.gettext.call(depth0 != null ? depth0 : {},"Woops, nothing is happening here.",{"name":"gettext","hash":{},"data":data}))
    + "\n";
},"useData":true})

});
